// extracted by mini-css-extract-plugin
export default {"loaderBox":"PageLoader_loaderBox__brrG1","value":"PageLoader_value__5FS-P"};